import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'ViewDashboard',
  data: function data() {
    return {
      valueDeterminate1: 70,
      valueDeterminate2: 30,
      valueDeterminate3: 10,
      Svalue: 80,
      imagetemp: './img/wabe.jpg',
      carouselItems: [{
        src: './img/example/cr01.jpg'
      }, {
        src: './img/example/cr02.jpg'
      }, {
        src: './img/example/cr03.jpg'
      }],
      treeItems: [{
        id: 1,
        name: 'Vuetify Human Resources',
        children: [{
          id: 2,
          name: 'Core team',
          children: [{
            id: 201,
            name: 'John'
          }, {
            id: 202,
            name: 'Kael'
          }, {
            id: 203,
            name: 'Nekosaur'
          }, {
            id: 204,
            name: 'Jacek'
          }, {
            id: 205,
            name: 'Andrew'
          }]
        }, {
          id: 3,
          name: 'Administrators',
          children: [{
            id: 301,
            name: 'Ranee'
          }, {
            id: 302,
            name: 'Rachel'
          }]
        }, {
          id: 4,
          name: 'Contributors',
          children: [{
            id: 401,
            name: 'Phlow'
          }, {
            id: 402,
            name: 'Brandon'
          }, {
            id: 403,
            name: 'Sean'
          }]
        }]
      }],
      open: [1, 2],
      search: null,
      caseSensitive: false,
      tiles: [{
        title: 'Industry',
        image: './img/dtwin-factory1.png'
      } // { title: 'Utilities', image: './img/dtwin-utilities.jpg' },
      // { title: 'Chemicals', image: './img/dtwin-factory.jpg' }
      ]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    filter: function filter() {
      return this.caseSensitive ? function (item, search, textKey) {
        return item[textKey].indexOf(search) > -1;
      } : undefined;
    }
  })
};